import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend, HttpHeaders, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import { Offers, PreviewOffer } from '../../core/models/offers.model';
import { URLS } from './url.constants';
import { ServerMock } from '../mocks/app-serve.mock';
import { environment } from '@environment';
import { map } from 'rxjs/operators';
import { OFFER_MOCK_PREVIEW } from '../mocks/app-control.mock';

const API_URL = environment.api_url;

@Injectable({
  providedIn: 'root',
})
export class OffersAPI {
  private _httpClient: HttpClient;
  private _localServer: ServerMock = new ServerMock();

  constructor(private _http: HttpClient, private _httpBackend: HttpBackend) {
    this._httpClient = new HttpClient(_httpBackend);
  }

  private _setTransactionHeaders(transactionToken: string):
    | HttpHeaders
    | {
        [header: string]: string | string[];
      } {
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${transactionToken}`,
    };
  }

  public getOffersByMerchant(amount: string): Observable<Offers[]> {
    const url: string = !!amount
      ? `${URLS.OFFERS_BY_MERCHANT}?amount=${amount}`
      : `${URLS.OFFERS_BY_MERCHANT}`;
    return this._http.get<Offers[]>(url);
  }

  public getOfferPreview(
    offerId: string,
    amount: string,
    numberOfInstallments: number,
    transactionToken: string
  ): Observable<PreviewOffer> {
    const httpRequest: any = OFFER_MOCK_PREVIEW;
    const { production, isTestServer } = environment;
    const options = {
      headers: this._setTransactionHeaders(transactionToken),
    };

    return production && !isTestServer
      ? this._httpClient.get<PreviewOffer>(
          `${API_URL}${URLS.OFFER_PREVIEW}/${offerId}/preview?amount=${amount}&number_of_installments=${numberOfInstallments}`,
          options
        )
      : this._localServer.request(httpRequest).pipe(
          map((response: HttpResponse<any>) => {
            const previewOffer: PreviewOffer = response?.body;
            return previewOffer;
          })
        );
  }
}
